/* eslint-disable react/jsx-filename-extension */
import React, { createContext, useContext } from 'react';
import logger from '../utils/logger';
import PropTypes from 'prop-types';

// Create a context for Services
const ServiceContext = createContext(null);

// Provider component that wraps app and makes services available
export const ServiceProvider = ({ children, services }) => (
  <ServiceContext.Provider value={services}>
    {children}
  </ServiceContext.Provider>
);

// Hook to use Services in any component
export const useServices = () => {
  const context = useContext(ServiceContext);
  if (context === null) {
    logger.error('useServices must be used within a ServiceProvider');
    // Return an empty object to prevent crashes
    return {};
  }
  return context;
};

ServiceProvider.propTypes = {
  children: PropTypes.node,
  // eslint-disable-next-line react/forbid-prop-types
  services: PropTypes.object,
};

ServiceProvider.defaultProps = {
  children: null,
  services: {},
};
